import { mq, SITE_VARIABLES } from '../../themes/variables'
import { StylesObject } from '../../types/styles'

export interface ThreeImageLinksTheme extends StylesObject {
    container: StylesObject
    childContainer: StylesObject
    middleContainer: StylesObject
    image: StylesObject
    gradient: StylesObject
    text: StylesObject
    line: StylesObject
}

export const getStylesObject = (siteVars: typeof SITE_VARIABLES, preview: boolean): ThreeImageLinksTheme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        height: '100%',
        gap: '10px',
        ...(preview && {
            height: '250px',
            flexDirection: 'row',
        }),
        ...(!preview && {
            [mq[0]]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                height: '266px',
            },
            [mq[1]]: {
                height: '250px',
            },
        }),
    },
    childContainer: {
        position: 'relative',
        overflow: 'hidden',
        height: '250px',
        ...(preview && {
            height: '100%',
        }),
        ...(!preview && {
            [mq[0]]: {
                height: '100%',
            },
        }),
    },
    middleContainer: {
        position: 'relative',
        overflow: 'hidden',
        height: '250px',
        ...(preview && {
            height: '100%',
        }),
        ...(!preview && {
            [mq[0]]: {
                height: '100%',
            },
        }),
    },
    image: {
        height: '100%',
        objectPosition: 'top',
        objectFit: 'cover',
        width: '100%',
    },
    gradient: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        top: '0',
        backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 61.09%, rgba(0, 0, 0, 0.80) 88.08%)',
    },
    text: {
        textAlign: 'left',
        position: 'absolute',
        zIndex: '1',
        paddingRight: '20px',
        ...siteVars.TYPOGRAPHY.big,
        margin: '0 auto',
        color: 'white',
        bottom: '30px',
        left: '20px',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    line: {
        content: '""',
        width: '40px',
        height: '1px',
        background: 'white',
        position: 'absolute',
        zIndex: '1',
        bottom: '20px',
        left: '20px',
    },
})
